import { request } from '.';
import { setUiState } from './ui';

const SET_ADS = 'SET_ADS';
const SET_AD = 'SET_AD';

const defaultState = { ads: [], ad: {} };

export default function reducer(state = defaultState, action) {
  switch (action.type) {
    case SET_ADS:
      return { ...state, ads: action.payload, ad: {} };

    case SET_AD:
      return { ...state, ad: action.payload };

    default:
      return state;
  }
}

export function setAd(ad) {
  return {
    type: SET_AD,
    payload: ad
  };
}
export function setAds(ads) {
  return {
    type: SET_ADS,
    payload: ads
  };
}
export function uploadAdImage(pId, data) {
  return dispatch =>
    new Promise(async (resolve, reject) => {
      try {
        dispatch(setUiState('loading'));
        const url = `/homepageAds/${pId}/images`;
        await request.post(url, data);
        dispatch(setUiState('complete'));
        return resolve();
      } catch (e) {
        dispatch(setUiState('error'));
        return reject(e);
      }
    });
}

export function getAd(id) {
  return dispatch => {
    return new Promise(async (resolve, reject) => {
      try {
        const url = `/homepageAds/${id}`;
        dispatch(setUiState('loading'));
        const response = await request.get(url);
        dispatch(setUiState('complete'));
        dispatch(setAd(response.data));
        return resolve();
      } catch (e) {
        dispatch(setUiState('error'));
        return reject(e);
      }
    });
  };
}

export function updateAd(id, data) {
  return dispatch => {
    return new Promise(async (resolve, reject) => {
      try {
        const url = `/homepageAds/${id}`;

        dispatch(setUiState('loading'));
        await request.put(url, data);
        dispatch(setUiState('complete'));

        return resolve();
      } catch (e) {
        dispatch(setUiState('error'));
        return reject(e);
      }
    });
  };
}

export function getAds() {
  return dispatch => {
    return new Promise(async (resolve, reject) => {
      try {
        const url = `/homepageAds`;

        dispatch(setUiState('loading'));
        const response = await request.get(url);
        if (response.data.length > 0) {
          dispatch(setUiState('complete'));
        } else {
          dispatch(setUiState('empty'));
        }

        dispatch(setAds(response.data));
        return resolve();
      } catch (e) {
        dispatch(setUiState('error'));
        return reject(e);
      }
    });
  };
}

export function createAd(ad) {
  return dispatch => {
    return new Promise(async (resolve, reject) => {
      try {
        const url = `/homepageAds`;

        dispatch(setUiState('loading'));
        const response = await request.post(url, ad);
        if (response.data.length > 0) {
          dispatch(setUiState('complete'));
        } else {
          dispatch(setUiState('empty'));
        }
        return resolve(response.data);
      } catch (e) {
        dispatch(setUiState('error'));
        return reject(e);
      }
    });
  };
}



// WEBPACK FOOTER //
// ./src/redux/homepageAds.js